import * as tslib_1 from "tslib";
import { isTranslatorEnabled } from 'owa-addins-core';
import { getFolderTable } from 'owa-folders';
import folderStore from 'owa-folders';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getFolderIdFromTableView } from 'owa-mail-search';
import isItemPartCommandBarOperation from 'owa-mail-list-store/lib/selectors/isItemPartCommandBarOperation';
import { isInboxRuleEnabledByAdmin } from 'owa-mail-rule-store';
import { default as mailStore } from 'owa-mail-store/lib/store/Store';
import isJunkEmailEnabledByAdmin from '../selectors/isJunkEmailEnabledByAdmin';
import * as undoActions from 'owa-mail-undo';
import { getUserConfiguration } from 'owa-session-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { getSelectedTableView, MailRowDataPropertyGetter, MailSortHelper, } from 'owa-mail-list-store';
import { shouldShowMenuItem, } from '../components/Behaviors';
import { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID, SHARED_FOLDERS_TREE_TYPE, isFolderOfTreeType, } from 'owa-folders';
import getFolderData from 'owa-mail-actions/lib/getFolderData';
var shouldShowBehaviorMap = {};
/**
 * Get a map which maps a mail filterable menu item to its ShouldShowBehavior
 */
export default function getMailMenuItemShouldShowMap() {
    if (shouldShowBehaviorMap) {
        initializeMap();
    }
    return shouldShowBehaviorMap;
}
/**
 * Initialize the ShouldShowBehaviors for mail menu items
 */
function initializeMap() {
    var inboxFolderId = 'inbox';
    var dumpsterFolderIds = [
        PRIMARY_DUMPSTER_DISTINGUISHED_ID,
        ARCHIVE_DUMPSTER_DISTINGUISHED_ID,
    ];
    var sentItemsFolderId = 'sentitems';
    var draftsFolderId = 'drafts';
    var deletedItemsFolderId = 'deleteditems';
    var junkFolderId = 'junkemail';
    var scheduledFolderId = 'scheduled';
    var clutterFolderId = 'clutter';
    var archiveFolderId = 'archive';
    // Show the menu item if list view has single selection
    shouldShowBehaviorMap[32 /* SingleSelection */] = shouldShowMenuItem([
        {
            selectionRestrictionType: 2 /* SingleSelection */,
        },
    ]);
    // Show overflow divider if
    // - in single selection
    // - not in recoverable items view
    shouldShowBehaviorMap[21 /* OverflowDivider */] = shouldShowMenuItem([
        {
            selectionRestrictionType: 2 /* SingleSelection */,
            folderRestrictionType: 1 /* Hide */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            foldersRestrictionList: dumpsterFolderIds,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show reply in command bar if
    // - not in recoverable items view
    // - there's a single selection
    // - it's not a group
    // - in message view
    shouldShowBehaviorMap[26 /* ReplyReplyAllForwardCommandBar */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            listViewTypeRestrictionType: 2 /* Message */,
        },
    ]);
    // Show reply if
    // - not in recoverable items view
    // - there's a single selection
    // - it's not a group
    shouldShowBehaviorMap[24 /* Reply */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show reply all and forward if
    // - not in recoverable items view
    // - there's a single selection
    shouldShowBehaviorMap[25 /* ReplyAllForward */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show the move menu item if list view has selection
    // - not in recoverable items view
    // - there's a selection
    // - it's not a group
    // - only in conversation view
    shouldShowBehaviorMap[16 /* Move */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            listViewTypeRestrictionType: 1 /* Conversation */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show schedule menu item if
    // - user is in inbox or scheduled
    // - there's a mail list item selection
    shouldShowBehaviorMap[30 /* Schedule */] = shouldShowMenuItem([
        {
            folderRestrictionType: 0 /* Show */,
            foldersRestrictionList: [inboxFolderId, scheduledFolderId],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            selectionRestrictionType: 0 /* HasSelection */,
            staticFolderSearchScopeRestrictionType: 0 /* Show */,
            staticFolderSearchScopeRestrictionList: [],
            customRestriction: function () {
                return isMailFeatureEnabled('tri-snooze');
            },
        },
    ]);
    // Show new message in right pane command bar
    // - when folder pane is collapsed
    shouldShowBehaviorMap[19 /* NewMessage */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return !mailStore.mailModule.showFolderPane;
            },
        },
    ]);
    // Show mark as read if
    // - not in recoverable items view
    // - list view has multiple selections
    // - or list view has single selection and selected row is unread
    shouldShowBehaviorMap[14 /* MarkAsRead */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return (
                // Show mark as read if
                // 1) List view has single selection AND row is unread AND we are not acting on item parts
                // 2) At least one selected item part is unread AND we are acting on item parts
                isItemPartCommandBarOperation(getSelectedTableView().id) ||
                    !isSingleSelectedRowRead());
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 1 /* SelectAll */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show mark as unread if not in recoverable items and list view has multiple selections
    // or list view has single selection and selected row is read
    shouldShowBehaviorMap[15 /* MarkAsUnread */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return (
                // Show mark as unread if
                // 1) List view has single selection AND row is read AND we are not acting on item parts
                // 2) At least one selected item part is read AND we are acting on item parts
                isItemPartCommandBarOperation(getSelectedTableView().id) ||
                    isSingleSelectedRowRead());
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            selectionRestrictionType: 1 /* SelectAll */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show flag if
    // - not in recoverable items view
    // - list view has multiple selections
    // - or list view has single selection and selected row is not flagged
    shouldShowBehaviorMap[8 /* Flag */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                // Show flag if
                // 1) It is shared folder and user has edit permission for shared folder
                return doesUserHaveSharedFolderPermissionFor(8 /* Flag */);
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return (
                // Show flag if
                // 1) List view has single selection AND row is unflagged AND we are not acting on item parts
                // 2) At least one selected item part is unflagged AND we are acting on item parts
                // 3) It is shared folder and user has edit permission for shared folder
                (isItemPartCommandBarOperation(getSelectedTableView().id) ||
                    !isSingleSelectedRowFlagged()) &&
                    doesUserHaveSharedFolderPermissionFor(8 /* Flag */));
            },
        },
    ]);
    // Show unflag if
    // - not in recoverable items view
    // - list view has multiple selections
    // - or list view has single selection and selected row is flagged
    shouldShowBehaviorMap[36 /* Unflag */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                // Show unflag if
                // 1) It is a shared folder and user has edit all permission
                return doesUserHaveSharedFolderPermissionFor(36 /* Unflag */);
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return (
                // Show unflag if
                // 1) List view has single selection AND row is flagged AND we are not acting on item parts
                // 2) At least one selected item part is flagged AND we are acting on item parts
                // 3) It is a shared folder and user has edit all permission
                (isItemPartCommandBarOperation(getSelectedTableView().id) ||
                    isSingleSelectedRowFlagged()) &&
                    doesUserHaveSharedFolderPermissionFor(36 /* Unflag */));
            },
        },
    ]);
    // Show categories if
    // - not in recoverable items view
    // - list view has selection
    // - not in groups
    // - user is in a shared folder and has edit all permission
    shouldShowBehaviorMap[4 /* Categories */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return doesUserHaveSharedFolderPermissionFor(4 /* Categories */);
            },
        },
    ]);
    // Show pin menu items
    // - in all folders except the ones in the restriction list
    // - and its not a archive mbx, group mbx
    // - (and list view has single selection and it's unpinned
    // ----- or list view has multiple selections)
    shouldShowBehaviorMap[22 /* Pin */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                junkFolderId,
                deletedItemsFolderId,
                scheduledFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            sortByRestrictionType: 0 /* Show */,
            sortByRestrictionList: [MailSortHelper.getSortBySupportingPin()],
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return !isSingleSelectedRowPinned();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                junkFolderId,
                deletedItemsFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            sortByRestrictionType: 0 /* Show */,
            sortByRestrictionList: [MailSortHelper.getSortBySupportingPin()],
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show pin menu items
    // - in all folders except the ones in the restriction list
    // - and not in archive mbx or group mbx
    // - and list view has single selection and it's pinned
    // ----- or list view has multiple selections
    shouldShowBehaviorMap[37 /* Unpin */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                junkFolderId,
                deletedItemsFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            sortByRestrictionType: 0 /* Show */,
            sortByRestrictionList: [MailSortHelper.getSortBySupportingPin()],
            selectionRestrictionType: 2 /* SingleSelection */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return isSingleSelectedRowPinned();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                junkFolderId,
                deletedItemsFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            sortByRestrictionType: 0 /* Show */,
            sortByRestrictionList: [MailSortHelper.getSortBySupportingPin()],
            selectionRestrictionType: 3 /* MultipleSelection */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show delete
    // - when list view has selection
    // - If it is shared folder and folder has delete all permission
    shouldShowBehaviorMap[6 /* Delete */] = shouldShowMenuItem([
        {
            selectionRestrictionType: 0 /* HasSelection */,
            customRestriction: function () {
                return doesUserHaveSharedFolderPermissionFor(6 /* Delete */);
            },
        },
        {
            selectionRestrictionType: 1 /* SelectAll */,
            customRestriction: function () {
                return doesUserHaveSharedFolderPermissionFor(6 /* Delete */);
            },
        },
    ]);
    // Show archive
    // - in folders under msgfolderroot except archive, deleted items, drafts, junk folder, and recoverable items
    // - and when list view has selection
    // - or if list view has selection in search
    shouldShowBehaviorMap[2 /* Archive */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                archiveFolderId,
                deletedItemsFolderId,
                draftsFolderId,
                junkFolderId
            ], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            mailboxType: 1 /* PrimaryMBX */,
            mailboxRestrictionType: 1 /* Show */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
        {
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 0 /* HasSelection */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show mark as junk
    // - when list view has selection
    // - and in folders under msgfolderroot except sent items, junk email, drafts, clutter, scheduled, and recoverable items
    // - or when list view has selection in search and the search refiner is not junkemail
    shouldShowBehaviorMap[12 /* MarkAsJunk */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                junkFolderId,
                clutterFolderId,
                scheduledFolderId
            ], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            mailboxType: 1 /* PrimaryMBX */,
            mailboxRestrictionType: 1 /* Show */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return isJunkEmailEnabledByAdmin();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: tslib_1.__spread([junkFolderId], dumpsterFolderIds),
            customRestriction: function () {
                return isJunkEmailEnabledByAdmin();
            },
        },
    ]);
    // Show mark as not junk
    // - in junk folder
    // - and when list view has selection
    // - or when list view has selection in search and the search refiner is junkemail
    // (But ALWAYS hide when in a ShadowMailbox)
    shouldShowBehaviorMap[13 /* MarkAsNotJunk */] = shouldShowMenuItem([
        {
            folderRestrictionType: 0 /* Show */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            mailboxType: 1 /* PrimaryMBX */,
            mailboxRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            foldersRestrictionList: [junkFolderId],
            selectionRestrictionType: 0 /* HasSelection */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            customRestriction: function () {
                return isJunkEmailEnabledByAdmin();
            },
        },
        {
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            staticFolderSearchScopeRestrictionType: 0 /* Show */,
            staticFolderSearchScopeRestrictionList: [junkFolderId],
            customRestriction: function () {
                return isJunkEmailEnabledByAdmin();
            },
        },
    ]);
    // Show ignore
    // - when list view has selection
    // - and not in Sent Items, drafts, deleted items, junk, or dumpster
    // (But ALWAYS hide when in a ShadowMailbox, Group mbx, Archive mbx)
    shouldShowBehaviorMap[9 /* Ignore */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                sentItemsFolderId,
                draftsFolderId,
                deletedItemsFolderId,
                junkFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            selectionRestrictionType: 0 /* HasSelection */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            customRestriction: function () {
                return isMailFeatureEnabled('tri-ignore');
            },
        },
    ]);
    // Show stop ignoring
    // - when list view has selection
    // - only in deleted items
    // (But ALWAYS hide when in a ShadowMailbox, Group mbx, Archive mbx)
    shouldShowBehaviorMap[33 /* StopIgnoring */] = shouldShowMenuItem([
        {
            folderRestrictionType: 0 /* Show */,
            foldersRestrictionList: [deletedItemsFolderId],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            selectionRestrictionType: 0 /* HasSelection */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            customRestriction: function () {
                return isMailFeatureEnabled('tri-ignore');
            },
        },
    ]);
    // Show block sender
    // - not in search(because search doesn't return lastSender property)
    // - when list view has selection with a LastSender property on the item
    // - and in folders under msgfolderroot except sent items, junk email, drafts, clutter, scheduled and recoverable items
    // - and when list view has single selection and it has valid smtp address
    shouldShowBehaviorMap[3 /* Block */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                scheduledFolderId
            ], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 2 /* SingleSelection */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
            customRestriction: function () { return doesSingleSelectionHasSmtp(); },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                draftsFolderId,
                sentItemsFolderId,
                clutterFolderId,
                scheduledFolderId
            ], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 3 /* MultipleSelection */,
            shadowMailboxRestrictionType: 1 /* HideForShadowMailbox */,
        },
    ]);
    // Show sweep
    // - in folders except sent, drafts, deleteditems, junk email, and recoverable items
    // - and the mbx is not archive, group
    // - and when user is not in search mode
    // - and when user is not in a category folder
    // - and when list view has
    // ------ multiple selections,
    // ------ OR single selection and it has smtp address
    shouldShowBehaviorMap[34 /* Sweep */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                sentItemsFolderId,
                draftsFolderId,
                deletedItemsFolderId,
                junkFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 2 /* SingleSelection */,
            viewFilterRestrictionType: 1 /* Hide */,
            viewFilterRestrictionList: ['UserCategory'],
            customRestriction: function () {
                return doesSingleSelectionHasSmtp();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([
                sentItemsFolderId,
                draftsFolderId,
                deletedItemsFolderId,
                junkFolderId
            ], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 3 /* MultipleSelection */,
            viewFilterRestrictionType: 1 /* Hide */,
            viewFilterRestrictionList: ['UserCategory'],
        },
    ]);
    // Show empty folder menu item if
    // - list view has items and has no selection
    // - not in groups
    // - is in Other inbox
    // - if in search or favorite node where selected folder id is null
    shouldShowBehaviorMap[7 /* EmptyFolder */] = shouldShowMenuItem([
        {
            focusedViewFilterRestrictionList: [1 /* Other */],
            listRestrictionType: 1 /* WithItems */,
            selectionRestrictionType: 4 /* NoSelection */,
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: [inboxFolderId],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            listRestrictionType: 1 /* WithItems */,
            selectionRestrictionType: 4 /* NoSelection */,
            customRestriction: function (selectedFolderDistinguishedId) {
                // This custom restriction is only valid for the folder table types
                // In this particular case we check for the distingusihed folder id.
                return isMailFolderTableShown() &&
                    selectedFolderDistinguishedId &&
                    (dumpsterFolderIds.indexOf(selectedFolderDistinguishedId) > -1 ||
                        isNotAllMailFolderTypeInShadowMailbox(selectedFolderDistinguishedId)) &&
                    doesUserHaveSharedFolderPermissionFor(6 /* Delete */);
            },
        },
        {
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            listRestrictionType: 1 /* WithItems */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 4 /* NoSelection */,
            customRestriction: function () {
                return doesUserHaveSharedFolderPermissionFor(6 /* Delete */);
            },
        },
        {
            // Show delete all for category folder
            listRestrictionType: 1 /* WithItems */,
            selectionRestrictionType: 4 /* NoSelection */,
            viewFilterRestrictionType: 0 /* Show */,
            viewFilterRestrictionList: ['UserCategory'],
        },
    ]);
    // Show mark all as read menu item
    // - not in recoverable items view
    // - and list view has unread item
    // - and list view has no selection
    shouldShowBehaviorMap[11 /* MarkAllAsRead */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            listRestrictionType: 1 /* WithItems */,
            selectionRestrictionType: 4 /* NoSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show the up/down/cancel icons
    // - when list view has single selection
    // - and in immersive reading pane, i.e. single line view
    shouldShowBehaviorMap[28 /* SelectionNavigation */] = shouldShowMenuItem([
        {
            readingPaneRestrictionType: 1 /* Immersive */,
        },
    ]);
    // Show restore if
    // - list view has selections
    // - and in deleteditems or dumpster folder
    // - and in search when the search scope is deleteditems for dumpster folder
    shouldShowBehaviorMap[27 /* Restore */] = shouldShowMenuItem([
        {
            selectionRestrictionType: 0 /* HasSelection */,
            folderRestrictionType: 0 /* Show */,
            foldersRestrictionList: tslib_1.__spread([deletedItemsFolderId], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            staticFolderSearchScopeRestrictionType: 0 /* Show */,
            staticFolderSearchScopeRestrictionList: tslib_1.__spread(dumpsterFolderIds, [deletedItemsFolderId]),
        },
    ]);
    // Show undo if
    // - not in recoverable items view
    // - not in archive mbx, group mbx
    // - list view has items
    // - .. or undo stack is not empty
    // - In folder list view
    // - When list pane is showing
    shouldShowBehaviorMap[35 /* Undo */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [0 /* Folder */],
            customRestriction: function () {
                return mailStore.mailModule.showListPane && undoActions.hasUndoableAction();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            listRestrictionType: 1 /* WithItems */,
            tableQueryTypeRestrictionType: 1 /* Show */,
            tableQueryTypeRestrictionList: [0 /* Folder */],
            customRestriction: function () {
                return mailStore.mailModule.showListPane;
            },
        },
    ]);
    // Show move to if
    // - Not in draft folder or recoverable items view
    // - Not in groups mbx
    // - list view has selection
    // - Shared folder has delete all permission
    shouldShowBehaviorMap[16 /* Move */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([draftsFolderId], dumpsterFolderIds),
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            selectionRestrictionType: 0 /* HasSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return doesUserHaveSharedFolderPermissionFor(16 /* Move */);
            },
        },
    ]);
    // Show inbox rule if
    // - not in sent items or drafts folders (until 'sent to' rule field is supported) or recoverable items view, and not a group
    // - and list view has single selection
    shouldShowBehaviorMap[10 /* InboxRule */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([sentItemsFolderId, draftsFolderId], dumpsterFolderIds),
            folderTreeTypeRestrictionList: [SHARED_FOLDERS_TREE_TYPE],
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            mailboxType: 2 /* ArchiveMBX */,
            mailboxRestrictionType: 2 /* Hide */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            searchScopeKindList: ["ArchiveMailbox" /* ArchiveMailbox */, "SharedFolders" /* SharedFolders */],
            searchScopeRestrictionType: 2 /* Hide */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: [sentItemsFolderId, draftsFolderId],
            customRestriction: function () {
                return isInboxRuleEnabledByAdmin() && doesSingleSelectionHasSmtp();
            },
        },
    ]);
    // Show move to Focused inbox menu item
    // - when is in Other inbox
    // - and list view has items
    // - and list view has selection
    // - and when not in search
    shouldShowBehaviorMap[17 /* MoveToFocusedInbox */] = shouldShowMenuItem([
        {
            focusedViewFilterRestrictionList: [1 /* Other */],
            listRestrictionType: 1 /* WithItems */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 0 /* HasSelection */,
        },
    ]);
    // Show move to Other inbox menu item
    // - when in Focused inbox
    // - and list view has items
    // - and list view has selection
    // - and when not in search
    shouldShowBehaviorMap[18 /* MoveToOtherInbox */] = shouldShowMenuItem([
        {
            focusedViewFilterRestrictionList: [0 /* Focused */],
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            listRestrictionType: 1 /* WithItems */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 0 /* HasSelection */,
        },
    ]);
    // Show always move to Focused inbox menu item
    // - when not in search
    // - list view has items
    // - and list view has single selection
    // - is in Other inbox
    shouldShowBehaviorMap[0 /* AlwaysMoveToFocusedInbox */] = shouldShowMenuItem([
        {
            focusedViewFilterRestrictionList: [1 /* Other */],
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            listRestrictionType: 1 /* WithItems */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 2 /* SingleSelection */,
        },
    ]);
    // Show always move to Other inbox menu item
    // - is in Focused inbox
    // - and list view has items
    // - and list view has single selection
    // - and when not in search
    shouldShowBehaviorMap[1 /* AlwaysMoveToOtherInbox */] = shouldShowMenuItem([
        {
            focusedViewFilterRestrictionList: [0 /* Focused */],
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            listRestrictionType: 1 /* WithItems */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            tableQueryTypeRestrictionList: [1 /* Search */],
            selectionRestrictionType: 2 /* SingleSelection */,
        },
    ]);
    shouldShowBehaviorMap[5 /* ClientOptOut */] = shouldShowMenuItem([
        {
            customRestriction: function () {
                var userConfiguration = getUserConfiguration();
                var userOptions = userConfiguration.UserOptions;
                return (mailStore.mailModule.showListPane &&
                    userOptions.ReactOptinSettings &&
                    !userOptions.IsPermanentlyOptedIn &&
                    !userOptions.ReactOptinSettings.MailGraduatedFromBeta &&
                    (userConfiguration.PolicySettings.OutlookBetaToggleEnabled !== undefined
                        ? userConfiguration.PolicySettings.OutlookBetaToggleEnabled
                        : true));
            },
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
        },
    ]);
    // Show Print menu
    // - in all folders except draft folder and recoverable items view
    // - and list view has single selection
    shouldShowBehaviorMap[23 /* Print */] = shouldShowMenuItem([
        {
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: tslib_1.__spread([draftsFolderId], dumpsterFolderIds),
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
        },
    ]);
    // Show "Translate" menu
    // - in all folders except draft folder and recoverable items view
    // - and list view has single selection
    shouldShowBehaviorMap[29 /* Translate */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            groupMailboxRestrictionType: 1 /* HideForGroupMailbox */,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            foldersRestrictionList: tslib_1.__spread([draftsFolderId], dumpsterFolderIds),
            selectionRestrictionType: 2 /* SingleSelection */,
            readingPaneRestrictionType: 2 /* Right */,
            tableQueryTypeRestrictionType: 0 /* Hide */,
            customRestriction: function () {
                return (isMailFeatureEnabled('gsx-translator-translateMessage') && isTranslatorEnabled());
            },
        },
    ]);
    // Show "Show in immersive reader" menu
    // - list view has single selection
    // - not in recoverable items view
    shouldShowBehaviorMap[31 /* ShowInImmersiveReader */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return isMailFeatureEnabled('rp-immersiveReader');
            },
        },
    ]);
    // Show "Open in new tab" menu
    // - list view has single selection
    // - not in recoverable items view
    shouldShowBehaviorMap[20 /* OpenInNewTab */] = shouldShowMenuItem([
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            selectionRestrictionType: 2 /* SingleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return isTabViewEnabled();
            },
        },
        {
            folderRestrictionType: 1 /* Hide */,
            foldersRestrictionList: dumpsterFolderIds,
            itemPartSelectionRestrictionType: 4 /* NoSelection */,
            selectionRestrictionType: 3 /* MultipleSelection */,
            staticFolderSearchScopeRestrictionType: 1 /* Hide */,
            staticFolderSearchScopeRestrictionList: dumpsterFolderIds,
            customRestriction: function () {
                return isTabViewEnabled();
            },
        },
    ]);
}
/**
 * Returns true if we are currently showing Folder type table for mail scenario
 */
function isMailFolderTableShown() {
    var tableView = getSelectedTableView();
    return (tableView.tableQuery.type == 0 /* Folder */ &&
        tableView.tableQuery.scenarioType == 'mail');
}
/**
 * Returns a flag indicating whether the current selected folder is not a "All Mail"
 * folder for a shadow mail box
 */
function isNotAllMailFolderTypeInShadowMailbox(selectedFolderDistinguishedId) {
    var selectedDistinguishedFolder = folderStore.folderTable.get(folderNameToId(selectedFolderDistinguishedId));
    // if both selectedDistinguishedFolder and sourceWellKnownFolderType are present
    // return true if the sourceWellKnownFolderType is not of type AllMail.
    if (selectedDistinguishedFolder && selectedDistinguishedFolder.sourceWellKnownFolderType) {
        return (selectedDistinguishedFolder.sourceWellKnownFolderType !==
            86 /* AllMail */);
    }
    // else return true
    return true;
}
/**
 * Returns true if list view has single selected row and it is read
 */
function isSingleSelectedRowRead() {
    var singleSelectedRowKey = getSingleSelectedRowKey();
    if (!singleSelectedRowKey) {
        // False when there is no selection or multiple selection
        return false;
    }
    var unreadCount = MailRowDataPropertyGetter.getUnreadCount(singleSelectedRowKey, getSelectedTableView());
    return unreadCount === 0;
}
/**
 * Returns true if list view has single selected row and it is flagged
 */
function isSingleSelectedRowFlagged() {
    var singleSelectedRowKey = getSingleSelectedRowKey();
    if (!singleSelectedRowKey) {
        // False when there is no selection or multiple selection
        return false;
    }
    var flagStatus = MailRowDataPropertyGetter.getFlagStatus(singleSelectedRowKey, getSelectedTableView());
    return flagStatus == 'Flagged';
}
/**
 * Returns true if list view has single selected row and it is pinned
 */
function isSingleSelectedRowPinned() {
    var singleSelectedRowKey = getSingleSelectedRowKey();
    if (!singleSelectedRowKey) {
        // False when there is no selection or multiple selection
        return false;
    }
    return MailRowDataPropertyGetter.getIsPinned(singleSelectedRowKey, getSelectedTableView());
}
/**
 * Returns true if single selected row data has smtp address
 */
function doesSingleSelectionHasSmtp() {
    var singleSelectedRowKey = getSingleSelectedRowKey();
    if (!singleSelectedRowKey) {
        // Hide 'Block' when there is no selection or multiple selection
        return false;
    }
    return !!MailRowDataPropertyGetter.getLastSenderSMTP(singleSelectedRowKey, getSelectedTableView());
}
/**
 * Returns the single selected mail list row id in list view, null if otherwise
 */
function getSingleSelectedRowKey() {
    var selectedRowKeys = tslib_1.__spread(getSelectedTableView().selectedRowKeys.keys());
    return selectedRowKeys.length == 1 ? selectedRowKeys[0] : null;
}
/**
 * Function return user assigned permission for the given folderId and user email address
 * If no permissions are present for user then return undefined
 * If there is no value in store for PermissionSet or Permissions then let the function throw error implicitly
 * @param folderId - folder for which the permissions will be calculated
 * @param userEmailAddress - user email for which permissions will be filtered
 */
function getUserPermissionForFolderIdWithErr(folderId, userEmailAddress) {
    if (!folderId || !userEmailAddress) {
        return null;
    }
    var selectedFolder = getFolderTable().get(folderId);
    var filteredFolderPermission = selectedFolder.PermissionSet.Permissions.filter(function (permission) { return permission.UserId.PrimarySmtpAddress === userEmailAddress; });
    var assignedFolderPermission = filteredFolderPermission && filteredFolderPermission[0];
    return assignedFolderPermission;
}
/**
 * This function is wrapper over getUserPermissionForFolderIdWithErr function that can handle error.
 * In case of error this function will return null to denote that there are no permissions.
 * @param folderId - folder for which the permissions will be calculated
 * @param userEmailAddress - user email for which permissions will be filtered
 */
export function getUserPermissionForFolderId(folderId, userEmailAddress) {
    try {
        return getUserPermissionForFolderIdWithErr(folderId, userEmailAddress);
    }
    catch (e) {
        return null;
    }
}
/**
 * Function checks if the user is given shared folder permission to delete, move or flag items
 * If permissions are present but they are empty then assume user has all permissions
 * If Permissions are not present in store then throw custom error
 * @param actionType - Menu item type for which permission will be calculated
 * @param externalFolderId - Folder id provided externally to this function for which permissions will be checked
 */
export function doesUserHaveSharedFolderPermissionForWithError(actionType, externalFolderId) {
    // If folder Id is not provided in argument then get the selected folder node
    var folderId = externalFolderId || getFolderIdFromTableView(getSelectedTableView());
    var isSharedFolder = isFolderOfTreeType(folderId, 'sharedFolderTree');
    // If not shared folder show all triage options
    if (!isSharedFolder) {
        return true;
    }
    var userEmail = getUserConfiguration().SessionSettings.UserEmailAddress;
    // Try getting permissions by calling getUserPermissionForFolderIdWithErr.
    // If there is error then call getFolderData to get this shared folder's permissions.
    // And throw error for the consumer of this function indicating that permissions are currently not present.
    try {
        var assignedFolderPermission = getUserPermissionForFolderIdWithErr(folderId, userEmail);
        return doesUserHaveActionPermission(actionType, assignedFolderPermission);
    }
    catch (e) {
        getFolderData(folderId);
        throw new Error('Move-To Error: Permissions for destination folder have not been fetched yet');
    }
}
/**
 * Function checks if the user has correct permissions to do certain triage actions
 * @param actionType - Menu item type for which permission will be calculated
 * @param assignedFolderPermission - the folder permission object
 */
export function doesUserHaveActionPermission(actionType, assignedFolderPermission) {
    // If permission object is null it means all permissions assigned
    if (!assignedFolderPermission) {
        return true;
    }
    switch (actionType) {
        // Show Move to and Delete options if
        // - User has delete all permission
        case 16 /* Move */:
        case 6 /* Delete */:
            return assignedFolderPermission.DeleteItems === 'All';
        // Show flag and categories options if
        // - User has edit all permission
        case 8 /* Flag */:
        case 36 /* Unflag */:
        case 4 /* Categories */:
            return assignedFolderPermission.EditItems === 'All';
    }
    return false;
}
/**
 * This function is a wrapper over doesUserHaveSharedFolderPermissionForWithError
 * This function assumes that if permissions data is not fetched yet then automatically permission is provided
 * @param actionType - Menu item type for which permission will be calculated
 * @param folderId - Folder id for which we want to know if permission is present or not
 */
export function doesUserHaveSharedFolderPermissionFor(actionType, folderId) {
    try {
        return doesUserHaveSharedFolderPermissionForWithError(actionType, folderId);
    }
    catch (e) {
        return true;
    }
}
//# sourceMappingURL=getMailMenuItemShouldShowMap.js.map